import MobileAppBar from '@/components/molecules/MobileAppBar';
import ProfileCreationForm from '@/components/organisms/ProfileCreationForm';
import { PAGE } from '@/routes';
import { getCurrentUser } from '@/store/slices/auth';
import { setBreadcrumbs } from '@/store/slices/breadcrumb';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const EditProfilePage = () => {
  const currentUser = useSelector(getCurrentUser);
  const dispatch = useDispatch();

  useEffect(() => {
    // Sets breadcrumbs when component mounts
    dispatch(
      setBreadcrumbs([
        {
          title: 'Profile',
          path: PAGE.PROFILE.path
        },
        {
          title: 'Edit Profile',
          path: ''
        }
      ])
    );
  }, []);

  return (
    <div className="pb-5">
      <MobileAppBar title="Edit Profile" />
      <ProfileCreationForm variant="edit" size="sm" profile={currentUser} />
    </div>
  );
};

export default EditProfilePage;
